import { Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { ConsentGuard } from '@guards/consent.guard';
import { KycConsentGuard } from '@guards/kyc-consent.guard';
import { LoginGuard } from '@guards/login.guard';
import { UserConfigResolver } from '@resolvers/user-config.resolver';

export const appRoutes: Routes = [
  {
    path: 'verify-registration/:id',
    title: 'pageTitle.verifyEmail',
    loadComponent: () =>
      import('@auth/verify-email/verify-email.component').then(
        (m) => m.VerifyEmailComponent
      )
  },
  {
    path: 'auth',
    loadChildren: () => import('@routes/auth.routes').then((m) => m.authRoutes),
    canMatch: [LoginGuard]
  },
  {
    path: '',
    loadComponent: () =>
      import('@pages/pages.component').then((m) => m.PagesComponent),
    canMatch: [AuthGuard],
    // The shell mounts (so the consent dialog can show over the dashboard, not
    // the login screen); ConsentGuard then holds a consent-owing user on the
    // dashboard by redirecting any deeper navigation until consent is granted.
    // KycConsentGuard does the same for the (second) KYC consent — together they
    // keep an un-consented user on the dashboard, in order: org consent, then KYC.
    canActivateChild: [ConsentGuard, KycConsentGuard],
    resolve: { userConfig: UserConfigResolver },
    children: [
      {
        path: '',
        redirectTo: '/auth',
        pathMatch: 'full'
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('@routes/admin.routes').then((m) => m.adminRoutes)
      }
    ]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
